"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const equal = require("fast-deep-equal");
class ValueObject {
    equals(other) {
        if (!other)
            return false;
        if (Object.is(this, other))
            return true;
        return equal(this, other);
    }
    // No valid hash implementation, so can't implement this function.
    // public hashCode(): number {
    //   let hashNum: number = 17;
    //   for (const obj of this.GetEqualityComponents()) {
    //     if (typeof obj === 'object' && !isValueObject(obj)) {
    //       throw new Error(`property value=${JSON.stringify(obj)} is not ValueObject, can not calculate hash.`);
    //     }
    //     hashNum = hashNum * 23 + (obj ? hash(obj): 0);
    //   }
    //   return hashNum;
    // }
    toString() {
        return JSON.stringify(this);
    }
}
exports.ValueObject = ValueObject;
//# sourceMappingURL=ValueObject.js.map